import { useQuery } from "@tanstack/react-query";
import {
  getDashboard,
  getVentureSupport,
  getVentureDueDiligence,
} from "../api";
import { ROLES } from "../constants/roles";
import { useAuth } from "../context/authContext";

export function useVentureDashboardHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["ventureDashboard", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getDashboard({
        token: resolvedToken,
        role: ROLES.VENTURE,
      });

      if (!result.ok) {
        throw new Error(result.error || "Unable to load venture dashboard");
      }

      return result.data;
    },
  });
}

export function useVentureSupportHook({ token, userId, enabled = true }) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["ventureSupport", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getVentureSupport({ token: resolvedToken });

      if (!result.ok) {
        throw new Error(result.error || "Unable to fetch support data");
      }

      return result.support;
    },
  });
}

export function useVentureDueDiligenceHook({
  token,
  userId,
  enabled = true,
}) {
  const auth = useAuth();
  const resolvedToken = token ?? auth.token;
  const resolvedUserId = userId ?? auth.user?.id;

  return useQuery({
    queryKey: ["ventureDueDiligence", resolvedUserId],
    enabled: enabled && !!resolvedToken && !!resolvedUserId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getVentureDueDiligence({ token: resolvedToken });

      if (!result.ok) {
        throw new Error(
          result.error || "Unable to load venture due diligence score.",
        );
      }

      return result.dueDiligence;
    },
  });
}
